import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../v3/Common/Token';

import {
  GstUserGstDataFetchUrl,
  GstUserPanDataFetchUrl,
  addManufacturerRoleToExistingFirmUrl,
  getBuyerRolesUrl,
  updateTokenUrl,
  getLocationAndPincodeUrl,
} from '../api';

export const getBuyerRolesAction = async (
  supplier_id,
  is_Ship_To_Party = false,
  is_sell_to_buyer = false,
  is_performance_module = false,
) => {
  const token = await getToken();
  return new Promise(async (next) => {
    await axios
      .get(
        `${getBuyerRolesUrl()}?supplier_id=${supplier_id}&is_ship_to_party=${is_Ship_To_Party}&is_sell_to_buyer=${is_sell_to_buyer}&is_performance_module=${is_performance_module}`,
        {
          ...getTokenHeader(token),
        },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
// onboading Gst fetch for details
export const GstUserGstDataFetch = async (gst) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserGstDataFetchUrl()}?gstin=${gst}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

// onboading PAN fetch for details
export const GstUserPanDataFetch = async (pan) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserPanDataFetchUrl()}?pan_no=${pan}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getProfilePicture = (profilePictureData) => {
  let data = `data:${profilePictureData?.media_type};base64,${profilePictureData?.file_data}`;
  return data;
};

export const updateTokenAction = async ({ company_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${updateTokenUrl()}?company_id=${company_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const refreshTokenAction = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(updateTokenUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const addManufacturerRoleToExistingFirmAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(addManufacturerRoleToExistingFirmUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getLocationAndPincodeAction = async (id, params = {}) => {
  return new Promise(async (next) => {
    await axios
      .get(`${getLocationAndPincodeUrl()}?district_id=${id}`, { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
